import { Route, Routes } from "react-router-dom";
import "./App.css";
import React, { Suspense } from "react";
import Navigation from "./components/Navigation";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./components/Footer";
import ScrollToTop from "./ScrollToTop";

const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Blog = React.lazy(() => import("./pages/Blogs/Blog"));
const PostOne = React.lazy(() => import("./pages/Blogs/posts/PostOne"));
const PostTwo = React.lazy(() => import("./pages/Blogs/posts/PostTwo"));
const PostThree = React.lazy(() => import("./pages/Blogs/posts/PostThree"));
const PostFour = React.lazy(() => import("./pages/Blogs/posts/PostFour"));
const NoPage = React.lazy(() => import("./pages/NoPage"));
const YasamKocuDestegi = React.lazy(() => import("./pages/YasamKocuDestegi"));
const EgitimOgrenciKocuDesteği = React.lazy(() =>
  import("./pages/EgitimOgrenciKocuDestegi")
);
const VeliDanismanligiDestegi = React.lazy(() =>
  import("./pages/VeliDanismanligiDestegi")
);
const KariyerKoclugu = React.lazy(() => import("./pages/KariyerKoclugu"));
const ProfesyonelKocluk = React.lazy(() => import("./pages/ProfesyonelKocluk"));
const EgitimDanismaniDestegi = React.lazy(() =>
  import("./pages/EgitimDanismaniDestegi")
);
const HizliOkumaAnlama = React.lazy(() => import("./pages/HizliOkumaAnlama"));
const HafizaTeknikleri = React.lazy(() => import("./pages/HafizaTeknikleri"));
const SpiritüelKocluk = React.lazy(() => import("./pages/SpiritüelKocluk"));
const PostFive = React.lazy(() => import("./pages/Blogs/posts/PostFive"));
const PostSix = React.lazy(() => import("./pages/Blogs/posts/PostSix"));
const PostSeven = React.lazy(() => import("./pages/Blogs/posts/PostSeven"));
const PostEight = React.lazy(() => import("./pages/Blogs/posts/PostEight"));

function App() {
  return (
    <>
      <ScrollToTop />

      <header>
        <Navigation />
      </header>

      <Suspense fallback={<div className="route-loading">Yükleniyor...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<Blog />} />
          <Route
            path="/blog/egitim-kocu-tanımlari-ve-görevleri"
            element={<PostOne />}
          />
          <Route
            path="/blog/basarili-bir-karar-verici-misin"
            element={<PostTwo />}
          />
          <Route path="/blog/karar-verirken-zorlanmak" element={<PostThree />} />
          <Route
            path="/blog/sosyal-etkilesimlerdeki-korku-endise"
            element={<PostFour />}
          />
          <Route
            path="/blog/bilsem-sınavını-kazanmanın-avantajları"
            element={<PostFive />}
          />
          <Route
            path="/blog/çocukların-öğrenme-stilini-keşfedin"
            element={<PostSix />}
          />
          <Route path="/blog/eğitim-hayatında-özgüven" element={<PostSeven />} />
          <Route
            path="/blog/yeni-dönem-öğrenci-etkili-hazırlık-süreci"
            element={<PostEight />}
          />
          <Route path="/hakkımızda" element={<About />} />
          <Route path="/iletişim" element={<Contact />} />
          <Route path="/yaşam-koçu-desteği" element={<YasamKocuDestegi />} />
          <Route
            path="/eğitim-öğrenci-koçu-desteği"
            element={<EgitimOgrenciKocuDesteği />}
          />
          <Route
            path="/veli-danışmanlığı-desteği"
            element={<VeliDanismanligiDestegi />}
          />
          <Route
            path="/kariyer-koçluğu-danışmanlık-desteği"
            element={<KariyerKoclugu />}
          />
          <Route
            path="/şirket-içi-eğitimler-profesyonel-koçluk-desteği"
            element={<ProfesyonelKocluk />}
          />
          <Route
            path="/eğitim-danışmanı-desteği"
            element={<EgitimDanismaniDestegi />}
          />
          <Route
            path="/hızlı-okuma-etkili-anlama-eğitimi"
            element={<HizliOkumaAnlama />}
          />
          <Route
            path="/hafıza-teknikleri-eğitimi"
            element={<HafizaTeknikleri />}
          />
          <Route path="/spiritüel-koçluk-desteği" element={<SpiritüelKocluk />} />
          <Route path="*" element={<NoPage />} />
        </Routes>
      </Suspense>

      <Footer />
    </>
  );
}

export default App;
